import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Generate or retrieve session ID
 */
const getSessionId = () => {
  let sessionId = sessionStorage.getItem('analytics_session_id');
  if (!sessionId) {
    sessionId = `${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
    sessionStorage.setItem('analytics_session_id', sessionId);
  }
  return sessionId;
};

/**
 * Detect device type
 */
const getDeviceType = () => {
  const ua = navigator.userAgent;
  if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
    return 'tablet';
  }
  if (/Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua)) {
    return 'mobile';
  }
  return 'desktop';
};

/**
 * useAnalytics - Hook to track page views
 * Place this in your main App component or layout
 */
export const useAnalytics = () => {
  const location = useLocation();
  const lastPath = useRef('');

  useEffect(() => {
    // Don't track admin pages
    if (location.pathname.startsWith('/admin')) {
      return;
    }

    // Avoid duplicate tracking for the same path
    if (lastPath.current === location.pathname) {
      return;
    }
    lastPath.current = location.pathname;

    // Extract event ID if on event detail page
    const eventMatch = location.pathname.match(/\/evento\/([^/]+)/);
    const eventId = eventMatch ? eventMatch[1] : null;

    // Track the page view
    const trackView = async () => {
      try {
        await axios.post(`${API}/analytics/track`, {
          page_path: location.pathname,
          page_title: document.title,
          referrer: document.referrer || null,
          device_type: getDeviceType(),
          session_id: getSessionId(),
          event_id: eventId
        });
      } catch (error) {
        // Silently fail - analytics should not break the app
        console.debug('Analytics tracking failed:', error);
      }
    };

    // Small delay to ensure page title is updated
    const timer = setTimeout(trackView, 500);
    return () => clearTimeout(timer);
  }, [location.pathname]);
};

export default useAnalytics;
